import { ensurePdfjsWorker, pdfjsLib } from '@/utils/pdfjsWorker';

/**
 * 使用 pdf.js 解析 PDF 的页数（不渲染页面，仅加载文档结构）。
 */
export async function countPdfPages(file: File): Promise<number> {
  ensurePdfjsWorker();
  const data = await file.arrayBuffer();
  const loadingTask = pdfjsLib.getDocument({ data: new Uint8Array(data) });
  const pdf = await loadingTask.promise;
  try {
    return pdf.numPages;
  } finally {
    await pdf.destroy();
  }
}
